import { render, staticRenderFns } from "./ImpressumContainer.vue?vue&type=template&id=ab156606&"
import script from "./ImpressumContainer.vue?vue&type=script&lang=js&"
export * from "./ImpressumContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports